import styled from "styled-components";

import { Textfield } from "@similarweb/ui-components";

export const TextfieldStyled = styled(Textfield)`
    width: 100%;
`;
